// eslint-disable-next-line no-unused-vars
import ko from 'knockout';
 
import '../../../../jsscripts/jquery/knockout/stopbindings.js';
import cart from './cart';
import colicareModals from '../../../colicare/modals';
import {onDOMContentLoaded} from '../../../dom/events';

onDOMContentLoaded(() => {
    cart.init();
    colicareModals.init();
});
